<template>
    <div>
        <slot></slot>
        <input type="hidden" :id="id" :name="name" v-model="dvalue">
    </div>
</template>

<script>
    import store from '../../store';
    import {mapState, mapActions, mapGetters} from 'vuex';

    const OrderInputShippingAddress = {
        name: 'ponroy-order-input-shipping-address',
        store,
        props: {
            id: {
                required: true,
            },
            name: {
                required: true,
            },
            value: {
                required: true,
            },
        },
        data() {
            return {
                dvalue : this.value,
            }
        },
        computed: {
            ...mapGetters('order', ['shippingAddress']),
        },
        watch: {
            shippingAddress: function(value) {
                if (value) {
                    this.dvalue = value.id
                } else {
                    this.dvalue = null;
                }
            }
        },
    };

    export default OrderInputShippingAddress;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/OrderInputShippingAddress.vue